import { useState, useEffect } from 'react';
import { Button, Container, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';
import axiosInstance from '../api/axiosInstance';

const Watrip = () => {
    // const commonStore = useSelector((state) => {
    //     return state.commonStore;
    // });
    const privateData = useSelector((state) => {
        return state.privateData;
    });

    let [map, setMap] = useState(null);
    const [isSpinning, setIsSpinning] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null); // 랜덤 스핀으로 선택된 단일 위치
    const [activeTab, setActiveTab] = useState('thingsToDo');

    // 각 탭의 데이터를 위한 상태 추가 (이제 배열로 관리)
    const [thingsToDoList, setThingsToDoList] = useState([]);
    const [accommodationList, setAccommodationList] = useState([]);
    const [eatData, setEatData] = useState([]); // 먹을거리 데이터도 배열로 관리
    const [petFriendlyList, setPetFriendlyList] = useState([]); // 반려동행 데이터 추가

    // 현재 지도에 표시된 마커와 정보창을 관리하기 위한 상태 추가
    const [randomLocationMarker, setRandomLocationMarker] = useState(null); // 랜덤 스핀 마커는 별도로 관리
    const [randomLocationInfowindow, setRandomLocationInfowindow] = useState(null); // 랜덤 스핀 정보창 별도 관리

    const [tabMarkers, setTabMarkers] = useState([]); // 탭 관련 마커 (즐길거리, 숙박정보, 먹을거리, 반려동행)
    const [tabInfowindows, setTabInfowindows] = useState([]); // 탭 관련 정보창 (즐길거리, 숙박정보, 먹을거리, 반려동행)

    // 이미지 팝업 관련 상태 추가
    const [showImageModal, setShowImageModal] = useState(false);
    const [currentFullImage, setCurrentFullImage] = useState('');


    // const dispatch = useDispatch();

    const fnObj = {
        titleList: {
            thingsToDoTab: {
                name: '이름',
                address: '주소',
                tel: '연락처',
                description: '설명'
            },
            eatTab: { // 먹을거리 탭 - '대표메뉴' 제거
                name: '상호명',
                category: '업종',
                address: '주소',
                tel: '연락처'
            },
            accommodationTab: {
                name: '숙소명',
                type: '유형',
                address: '주소',
                tel: '연락처',
                priceRange: '가격대'
            },
            petFriendlyTab: { // 반려동행 탭 추가
                name: '여행지',
                address: '주소',
                tel: '연락처',
                preview: '미리보기'
            }
        },
        mapObj: {
            mapContainer: null,
            mapOption: {
                center: new window.kakao.maps.LatLng(36.5, 127.8),
                level: 13,
                mapTypeId: window.kakao.maps.MapTypeId.HYBRID
            },
            map: null
        },
        getKakaoMapInit() {
            let mapContainer = document.getElementById('map');
            let mapOption = fnObj.mapObj.mapOption;

            if (!map && mapContainer) {
                const newMap = new window.kakao.maps.Map(mapContainer, mapOption);
                newMap.setDraggable(true);
                newMap.setZoomable(true);
                setMap(newMap);
                fnObj.mapObj.map = newMap;

                const mapTypeControl = new window.kakao.maps.MapTypeControl();
                newMap.addControl(mapTypeControl, window.kakao.maps.ControlPosition.TOPRIGHT);
            }
        },
        init() {
            fnObj.getKakaoMapInit();
        },
        async getAddressFromCoords(lat, lon) {
            try {
                const response = await axios.get(
                    `https://dapi.kakao.com/v2/local/geo/coord2address.json?x=${lon}&y=${lat}`,
                    {
                        headers: {
                            Authorization: `KakaoAK 25ed599edb1d19aa8c1da066c5fb6a80`
                        }
                    }
                );

                if (response.data.documents.length > 0) {
                    const addressInfo = response.data.documents[0];
                    return addressInfo.road_address ? addressInfo.road_address.address_name : addressInfo.address.address_name;
                } else {
                    return "주소를 찾을 수 없음";
                }
            } catch (error) {
                console.error("주소 변환 오류:", error);
                return "주소 변환 오류 발생";
            }
        },
        async spinRoulette() {
            setIsSpinning(true);

            // 기존 모든 마커와 정보창 제거
            if (randomLocationMarker) randomLocationMarker.setMap(null);
            if (randomLocationInfowindow) randomLocationInfowindow.close();
            tabMarkers.forEach(marker => marker.setMap(null));
            tabInfowindows.forEach(infowindow => infowindow.close());
            setRandomLocationMarker(null);
            setRandomLocationInfowindow(null);
            setTabMarkers([]);
            setTabInfowindows([]);

            setTimeout(async () => {
                setIsSpinning(false);

                let randomLat, randomLon;
                let address = "주소 확인 중...";
                let attempts = 0;
                const maxAttempts = 10;

                do {
                    randomLat = 35 + Math.random() * (37.5 - 35); // 위도 범위
                    randomLon = 126.5 + Math.random() * (129 - 126.5); // 경도 범위
                    address = await fnObj.getAddressFromCoords(randomLat, randomLon);
                    attempts++;
                } while ((address === "주소를 찾을 수 없음" || address.includes("오류")) && attempts < maxAttempts);

                const newLocation = new window.kakao.maps.LatLng(randomLat, randomLon);

                const locationData = {
                    lat: randomLat,
                    lon: randomLon,
                    name: address.split(' ')[0] || '랜덤 여행지',
                    address: address
                };
                setSelectedLocation(locationData); // 선택된 위치 상태 업데이트

                // 1. 랜덤 스핀 위치 마커 추가 (빨간색)
                if (map) {
                    const randomMarkerImage = new window.kakao.maps.MarkerImage(
                        'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/marker_red.png', // 빨간색 단일 마커 이미지
                        new window.kakao.maps.Size(31, 35), // 마커 이미지 크기
                        { offset: new window.kakao.maps.Point(13, 35) } // 마커 이미지의 좌표에 일치시킬 기준점 (보통 바닥 중앙)
                    );

                    const marker = new window.kakao.maps.Marker({
                        map: map,
                        position: newLocation,
                        image: randomMarkerImage
                    });
                    const infowindow = new window.kakao.maps.InfoWindow({
                        position: newLocation,
                        content: `<div style="padding:5px;"><b>현재 위치: ${address}</b></div>`
                    });
                    infowindow.open(map, marker);
                    setRandomLocationMarker(marker);
                    setRandomLocationInfowindow(infowindow);
                }

                // --- n8n axios 요청 및 데이터 처리 부분 ---
                try {
                    const response = await axiosInstance.get(`waleuleu/tour?latitude=${randomLat}&longitude=${randomLon}&radius=10`);
                    const watripDetailList = response.data;

                    const thingsToDo = [];
                    const accommodation = [];

                    if (watripDetailList) {
                        watripDetailList.forEach(item => {
                            const addressToUse = item.newaddress || item.oldaddress || "주소 정보 없음";
                            const displayTel = item.telno || "연락처 정보 없음";
                            const displayNote = item.note || "설명 정보 없음";

                            if (item.statuscd === 'P' || item.statuscd === 'T') { // 즐길거리
                                thingsToDo.push({
                                    id: item.id,
                                    tournm: item.tournm,
                                    address: addressToUse,
                                    telno: displayTel,
                                    note: displayNote,
                                    latitude: item.latitude,
                                    longitude: item.longitude
                                });
                            } else if (item.statuscd === 'H') { // 숙박정보
                                accommodation.push({
                                    id: item.id,
                                    tournm: item.tournm,
                                    type: '펜션', // 강제 등록
                                    address: addressToUse,
                                    telno: displayTel,
                                    latitude: item.latitude,
                                    longitude: item.longitude
                                });
                            }
                        });
                    }

                    setThingsToDoList(thingsToDo);
                    setAccommodationList(accommodation);

                    // --- 먹을거리 API 호출 및 데이터 처리 ---
                    const addressParts = address.split(' ');
                    const siNm = addressParts[0]; // 시도명 (e.g., "경기도", "강원특별자치도")
                    const sidoNm = addressParts[1]; // 시군구명 (e.g., "화성시", "원주시")

                    let fetchedEatData = [];
                    if (siNm && sidoNm) {
                        try {
                            const restaurantResponse = await axiosInstance.get(
                                `/waleuleu/restaurant?RELAX_SI_NM=${encodeURIComponent(siNm)}&RELAX_SIDO_NM=${encodeURIComponent(sidoNm)}`
                            );

                            const restaurantDataRaw = restaurantResponse.data[0]?.Grid_20200713000000000605_1?.row || [];

                            // 랜덤으로 10개만 선택
                            const shuffled = restaurantDataRaw.sort(() => 0.5 - Math.random());
                            const selectedRestaurants = shuffled.slice(0, 10); // 최대 10개 선택

                            for (const item of selectedRestaurants) { // 선택된 10개에 대해서만 반복
                                const fullAddress = `${item.RELAX_ADD1 || ''} ${item.RELAX_ADD2 || ''}`.trim();
                                let lat = null;
                                let lon = null;

                                if (fullAddress && fullAddress !== "주소 정보 없음") {
                                    try {
                                        const geocodeResponse = await axios.get(
                                            `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURIComponent(fullAddress)}`,
                                            {
                                                headers: {
                                                    Authorization: `KakaoAK 25ed599edb1d19aa8c1da066c5fb6a80`
                                                }
                                            }
                                        );
                                        if (geocodeResponse.data.documents.length > 0) {
                                            lat = geocodeResponse.data.documents[0].y; // latitude
                                            lon = geocodeResponse.data.documents[0].x; // longitude
                                        }
                                    } catch (geocodeError) {
                                        console.error("Geocoding error for restaurant:", fullAddress, geocodeError);
                                    }
                                }

                                fetchedEatData.push({
                                    id: item.RELAX_SEQ, // Using sequence number as ID
                                    tournm: item.RELAX_RSTRNT_NM, // 상호명
                                    category: item.RELAX_GUBUN_DETAIL, // 업종
                                    address: fullAddress, // 주소
                                    telno: item.RELAX_RSTRNT_TEL, // 연락처
                                    latitude: lat,
                                    longitude: lon
                                });
                            }
                        } catch (restaurantApiError) {
                            console.error("Failed to fetch restaurant data:", restaurantApiError);
                        }
                    }
                    setEatData(fetchedEatData);
                    // --- 먹을거리 API 호출 및 데이터 처리 끝 ---

                    // --- 반려동행 API 호출 및 데이터 처리 ---
                    let fetchedPetFriendlyData = [];
                    try {
                        const petFriendlyResponse = await axiosInstance.get(
                            `/waleuleu/pet?mapX=${randomLon}&mapY=${randomLat}` // mapX, mapY 파라미터 사용
                        );

                        // 응답 데이터 구조에 맞게 파싱
                        const petFriendlyRaw = petFriendlyResponse.data[0]?.response?.body?.items?.item || [];

                        fetchedPetFriendlyData = petFriendlyRaw.map(item => {
                            const fullAddress = `${item.addr1 || ''} ${item.addr2 || ''}`.trim();
                            return {
                                id: item.contentid, // 콘텐츠 ID를 ID로 사용
                                tournm: item.title, // 여행지명
                                address: fullAddress, // 주소
                                telno: item.tel, // 전화번호
                                firstimage: item.firstimage, // 큰 이미지 URL 추가
                                firstimage2: item.firstimage2, // 미리보기 이미지 URL
                                latitude: parseFloat(item.mapy), // mapY가 위도
                                longitude: parseFloat(item.mapx) // mapX가 경도
                            };
                        });
                    } catch (petFriendlyApiError) {
                        console.error("Failed to fetch pet-friendly data:", petFriendlyApiError);
                    }
                    setPetFriendlyList(fetchedPetFriendlyData);
                    // --- 반려동행 API 호출 및 데이터 처리 끝 ---


                    // 데이터 로드 후 자동으로 즐길거리 탭 활성화 및 마커 표시
                    setActiveTab('thingsToDo');
                    // 반려동행 데이터도 함께 전달
                    fnObj.updateTabMarkers('thingsToDo', thingsToDo, accommodation, newLocation, fetchedEatData, fetchedPetFriendlyData);

                } catch (error) {
                    console.error("Failed to send Latitude and Longitude to webhook:", error);
                    setThingsToDoList([]);
                    setAccommodationList([]);
                    setEatData([]); // 에러 발생 시 먹을거리 데이터도 초기화
                    setPetFriendlyList([]); // 에러 발생 시 반려동행 데이터도 초기화
                }
                // -----------------------------

            }, 3000);
        },

        // 탭에 따라 마커를 갱신하는 함수
        updateTabMarkers(activeTabId, thingsToDoData, accommodationData, randomLoc, eatData, petFriendlyData) { // petFriendlyData 파라미터 추가
            if (!map) return;

            // 기존 탭 마커 및 정보창 제거
            tabMarkers.forEach(marker => marker.setMap(null));
            tabInfowindows.forEach(infowindow => infowindow.close());
            setTabMarkers([]);
            setTabInfowindows([]);

            let currentTabMarkers = [];
            let currentTabInfowindows = [];
            let allMarkersPositions = [];

            // 랜덤 위치 마커가 있다면 그 위치를 포함 (지도 범위 조정을 위함)
            if (randomLoc) {
                allMarkersPositions.push(randomLoc);
            }

            const starMarkerImage = new window.kakao.maps.MarkerImage(
                'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/markerStar.png', // 별 마커 이미지
                new window.kakao.maps.Size(24, 35), // 마커 이미지 크기
                { offset: new window.kakao.maps.Point(12, 35) } // 마커 이미지의 좌표에 일치시킬 기준점
            );

            const addMarkersForTab = (dataList) => {
                dataList.forEach(item => {
                    if (item.latitude && item.longitude) {
                        const position = new window.kakao.maps.LatLng(item.latitude, item.longitude);
                        const marker = new window.kakao.maps.Marker({
                            map: map,
                            position: position,
                            image: starMarkerImage // 별 마커 이미지 사용
                        });

                        // tournm과 address 함께 출력하도록 수정
                        const iwContent = `<div style="padding:5px;"><b>${item.tournm || '이름 없음'}</b></div>`;
                        const infowindow = new window.kakao.maps.InfoWindow({
                            position: position,
                            content: iwContent
                        });

                        window.kakao.maps.event.addListener(marker, 'click', function () {
                            currentTabInfowindows.forEach(iw => iw.close()); // 다른 정보창 닫기
                            infowindow.open(map, marker);
                        });

                        currentTabMarkers.push(marker);
                        currentTabInfowindows.push(infowindow);
                        allMarkersPositions.push(position);
                    }
                });
            };

            if (activeTabId === 'thingsToDo' && thingsToDoData) {
                addMarkersForTab(thingsToDoData);
            } else if (activeTabId === 'accommodation' && accommodationData) {
                addMarkersForTab(accommodationData);
            } else if (activeTabId === 'eat' && eatData) { // 먹을거리 탭인 경우
                addMarkersForTab(eatData);
            } else if (activeTabId === 'petFriendly' && petFriendlyData) { // 반려동행 탭인 경우
                addMarkersForTab(petFriendlyData);
            }

            setTabMarkers(currentTabMarkers);
            setTabInfowindows(currentTabInfowindows);

            // 모든 마커가 보이도록 지도 범위 조정
            if (allMarkersPositions.length > 0) {
                const bounds = new window.kakao.maps.LatLngBounds();
                allMarkersPositions.forEach(pos => bounds.extend(pos));
                map.setBounds(bounds);
            } else if (randomLoc) { // 탭 데이터가 없고 랜덤 위치만 있다면 랜덤 위치로 중심 이동
                map.setCenter(randomLoc);
                map.setLevel(3);
            }
        },

        showTab(tabId) {
            setActiveTab(tabId);
            // 탭 변경 시 해당 탭의 마커를 업데이트 (현재 가지고 있는 모든 데이터 전달)
            // 반려동행 데이터도 함께 전달
            fnObj.updateTabMarkers(tabId, thingsToDoList, accommodationList, selectedLocation ? new window.kakao.maps.LatLng(selectedLocation.lat, selectedLocation.lon) : null, eatData, petFriendlyList);
        },

        // 이미지 팝업 열기 함수
        openImageModal(imageUrl) {
            setCurrentFullImage(imageUrl);
            setShowImageModal(true);
        },
        // 이미지 팝업 닫기 함수
        closeImageModal() {
            setShowImageModal(false);
            setCurrentFullImage('');
        }
    };

    // 카카오맵 스크립트 로딩 및 초기화
    useEffect(() => {
        const script = document.createElement("script");
        script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=252789b38c66bb62dc7212f1c1176ea0&libraries=services,clusterer,drawing,util`;
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            console.log("✅ 카카오 맵 로드 완료");
            fnObj.mapObj.mapContainer = document.getElementById("map");
            if (fnObj.mapObj.mapContainer) {
                fnObj.init();
            } else {
                console.error("❌ `#map` 요소를 찾을 수 없음.");
            }
        };

        return () => {
            document.head.removeChild(script);
        };
    }, [privateData.kakaoMapApiKey]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <Container>
                <div className="watrip-roulette-container">
                    <div id="map" className={`watrip-map-container ${isSpinning ? 'watrip-blurred' : ''}`}></div>
                    {isSpinning && (
                        <div className="watrip-roulette-overlay">
                            <div className="watrip-roulette-wheel">
                                <div className="watrip-spinner"></div>
                                <p>Wa!르르 여행 돌림판!</p>
                            </div>
                        </div>
                    )}
                    <div className="watrip-roulette-button-area">
                        <Button
                            variant="primary"
                            onClick={fnObj.spinRoulette}
                            disabled={isSpinning}
                            className="watrip-wa-roulette-button"
                        >
                            Wa!르르 돌림판
                        </Button>
                    </div>
                </div>

                <div style={{ width: '100%', marginTop: '20px' }}>
                    <Nav justify variant="tabs" activeKey={activeTab} onSelect={fnObj.showTab}>
                        <Nav.Item>
                            <Nav.Link eventKey="thingsToDo">즐길거리</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="eat">먹을거리</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="accommodation">숙박정보</Nav.Link>
                        </Nav.Item>
                        <Nav.Item> {/* 반려동행 탭 추가 */}
                            <Nav.Link eventKey="petFriendly">반려동행</Nav.Link>
                        </Nav.Item>
                    </Nav>

                    {/* 즐길거리 테이블 */}
                    <div id="thingsToDo" className="watrip-table-section" style={{ display: activeTab === 'thingsToDo' ? 'block' : 'none' }}>
                        {thingsToDoList.length > 0 ? (
                            <div className="watrip-grid">
                                {thingsToDoList.map((item, index) => (
                                    <div key={`thingsToDo-${item.id}-${index}`} className="watrip-card things-to-do">
                                        <div>
                                            <div className="watrip-card-title">{item.tournm}</div>
                                            <span className="watrip-card-badge">즐길거리</span>
                                            <div className="watrip-card-info">
                                                <strong>주소:</strong> {item.address}
                                            </div>
                                            <div className="watrip-card-info">
                                                <strong>연락처:</strong> {item.telno && item.telno !== "연락처 정보 없음" ? item.telno : "정보 없음"}
                                            </div>
                                        </div>
                                        {item.note && item.note !== "설명 정보 없음" && (
                                            <div className="watrip-card-desc">{item.note}</div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="alert alert-light text-center p-5 border rounded small text-muted">
                                돌림판을 돌려 주변 즐길거리를 찾아주세요. 🎡
                            </div>
                        )}
                    </div>

                    {/* 먹을거리 테이블 */}
                    <div id="eat" className="watrip-table-section" style={{ display: activeTab === 'eat' ? 'block' : 'none' }}>
                        {eatData.length > 0 ? (
                            <div className="watrip-grid">
                                {eatData.map((item, index) => (
                                    <div key={`eat-${item.id}-${index}`} className="watrip-card eat">
                                        <div>
                                            <div className="watrip-card-title">{item.tournm}</div>
                                            <span className="watrip-card-badge" style={{ backgroundColor: '#fffaf0', color: '#dd6b20', border: '1px solid #fbd38d' }}>
                                                {item.category || "식당"}
                                            </span>
                                            <div className="watrip-card-info">
                                                <strong>주소:</strong> {item.address}
                                            </div>
                                            <div className="watrip-card-info">
                                                <strong>연락처:</strong> {item.telno && item.telno !== "연락처 정보 없음" ? item.telno : "정보 없음"}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="alert alert-light text-center p-5 border rounded small text-muted">
                                돌림판을 돌려 주변 먹을거리를 찾아주세요. 🍜
                            </div>
                        )}
                    </div>

                    {/* 숙박정보 테이블 */}
                    <div id="accommodation" className="watrip-table-section" style={{ display: activeTab === 'accommodation' ? 'block' : 'none' }}>
                        {accommodationList.length > 0 ? (
                            <div className="watrip-grid">
                                {accommodationList.map((item, index) => (
                                    <div key={`accommodation-${item.id}-${index}`} className="watrip-card accommodation">
                                        <div>
                                            <div className="watrip-card-title">{item.tournm}</div>
                                            <span className="watrip-card-badge" style={{ backgroundColor: '#e6fffa', color: '#319795', border: '1px solid #b2f5ea' }}>
                                                {item.type || "숙소"}
                                            </span>
                                            <div className="watrip-card-info">
                                                <strong>주소:</strong> {item.address}
                                            </div>
                                            <div className="watrip-card-info">
                                                <strong>연락처:</strong> {item.telno && item.telno !== "연락처 정보 없음" ? item.telno : "정보 없음"}
                                            </div>
                                            {item.priceRange && (
                                                <div className="watrip-card-info">
                                                    <strong>가격대:</strong> {item.priceRange}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="alert alert-light text-center p-5 border rounded small text-muted">
                                돌림판을 돌려 주변 숙박 정보를 찾아주세요. 🏨
                            </div>
                        )}
                    </div>

                    {/* 반려동행 테이블 */}
                    <div id="petFriendly" className="watrip-table-section" style={{ display: activeTab === 'petFriendly' ? 'block' : 'none' }}>
                        {petFriendlyList.length > 0 ? (
                            <div className="watrip-grid">
                                {petFriendlyList.map((item, index) => (
                                    <div key={`petFriendly-${item.id}-${index}`} className="watrip-card pet-friendly">
                                        <div>
                                            <div className="watrip-card-title">{item.tournm}</div>
                                            <span className="watrip-card-badge" style={{ backgroundColor: '#faf5ff', color: '#805ad5', border: '1px solid #e9d8fd' }}>
                                                반려동행 가능
                                            </span>
                                            <div className="watrip-card-info">
                                                <strong>주소:</strong> {item.address}
                                            </div>
                                            <div className="watrip-card-info">
                                                <strong>연락처:</strong> {item.telno && item.telno !== "연락처 정보 없음" ? item.telno : "정보 없음"}
                                            </div>
                                        </div>
                                        {item.firstimage2 ? (
                                            <img
                                                src={item.firstimage2}
                                                alt={item.tournm}
                                                className="watrip-card-pet-img"
                                                onClick={() => fnObj.openImageModal(item.firstimage)}
                                            />
                                        ) : (
                                            <div className="text-center p-3 text-muted small bg-light rounded mt-2 border border-dashed" style={{ fontSize: '11px' }}>
                                                이미지 준비중 🐾
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="alert alert-light text-center p-5 border rounded small text-muted">
                                돌림판을 돌려 주변 반려동행 정보를 찾아주세요. 🐶
                            </div>
                        )}
                    </div>
                </div>
            </Container>

            {/* 이미지 팝업 모달 */}
            {showImageModal && (
                <div
                    className="image-modal-overlay"
                    onClick={fnObj.closeImageModal} // 오버레이 클릭 시 모달 닫기
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)', // 반투명 검정 배경
                        backdropFilter: 'blur(5px)', // 블러 효과
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000 // 다른 요소 위에 표시
                    }}
                >
                    <div
                        className="image-modal-content"
                        onClick={(e) => e.stopPropagation()} // 이미지 클릭 시 모달 닫히지 않게 함
                        style={{
                            position: 'relative',
                            padding: '20px',
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            maxWidth: '90%',
                            maxHeight: '90%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <span
                            className="close-button"
                            onClick={fnObj.closeImageModal} // X 버튼 클릭 시 모달 닫기
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '20px',
                                fontSize: '30px',
                                cursor: 'pointer',
                                color: '#333'
                            }}
                        >
                            &times;
                        </span>
                        <img
                            src={currentFullImage}
                            alt="Full size"
                            style={{ maxWidth: '100%', maxHeight: 'calc(100vh - 80px)', display: 'block' }} // 뷰포트 높이 고려
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export { Watrip };